<template>
    
    <v-dialog v-model="app.details.show">


      <v-card class="custom-card resize">

        <iframe
            v-if="containsAddress && showMap"
          id="gmap_canvas"
          width="100%"
          height="275px"
          :src="mapSource"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        />

        <v-card
            v-if="!containsAddress || !showMap"
            :color="app.color"
            :height="headerHeight(this.$vuetify)"
            >
            <v-container fluid class="fill-height">
            
                <v-layout wrap justify-center="" align-center="" class="text-center">
            
                <v-flex xs12 class="text-center">
                    <v-layout justify-center="" fill-height="" wrap>
                    <v-flex xs12>
                        <v-icon color="white" size="75">{{object.category.icon}}</v-icon>
                    </v-flex>
                    <v-flex xs12>
                        <span class="headline font-weight-thin white--text">{{object.details.name}}</span>
                    </v-flex>
                    <v-flex xs12>
                        <span class="subheading font-weight-thin white--text">({{object.category.description}})</span>
                    </v-flex>
                    </v-layout>
                </v-flex>
                </v-layout>               
            </v-container>
            </v-card>

              <v-btn 
                top
                right=""
                absolute=""
                icon color="error" @click="app.details.show = false">
                <v-icon large>mdi-close-circle-outline</v-icon>
              </v-btn>
            
                <v-container fluid class="pa-5" v-if="objectType == 'object'">
                  <v-layout wrap>
                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change"  label="Naam" v-model="object.details['name']" class="pl-2"></fields-d-text-field>                       
                      </v-flex>

                    <v-flex sm4 xs12 v-for="(field, index) in object.category.fields" :key="index" class="pl-2">
                        <fields-d-text-field    @input="change"             v-if="field.type == 'text'"     :label="field.name" v-model="object.details[field.field]"></fields-d-text-field>                       
                        <fields-d-email-field   @input="change"             v-if="field.type == 'email'"    :label="field.name" v-model="object.details[field.field]"></fields-d-email-field>    
                        <fields-d-phone-field   @input="change"             v-if="field.type == 'phone'"                        v-model="object.details[field.field]"></fields-d-phone-field>    
                        <fields-d-address-field @blur="change"              v-if="field.type == 'address'"                                                           ></fields-d-address-field>
                        <fields-d-address-field @blur="change" estate       v-if="field.type == 'estate'"                                                            ></fields-d-address-field>
                        <fields-d-date-object-field @blur="change"          v-if="field.type == 'date'"     :label="field.name" v-model="object.details[field.field]"></fields-d-date-object-field>                       
                        <fields-d-switch        @input="change"             v-if="field.type == 'switch'"   :label="field.name" v-model="object.details[field.field]"></fields-d-switch>
                        <fields-d-checkbox      @input="change"             v-if="field.type == 'checkbox'" :label="field.name" v-model="object.details[field.field]"></fields-d-checkbox>
                        <fields-d-yes-no        @input="change"             v-if="field.type == 'yes-no'"   :label="field.name" v-model="object.details[field.field]"></fields-d-yes-no>
                        <fields-d-text-area     @input="change"             v-if="field.type == 'textarea'" :label="field.name" v-model="object.details[field.field]"></fields-d-text-area>                       
                    </v-flex> 

                  </v-layout>
                </v-container>

                <v-container fluid class="pa-5" v-if="objectType == 'estate'">         
                  <v-layout wrap>
                      <v-flex sm6 xs12 class="pl-2">
                          <fields-d-address-field @blur="change" estate></fields-d-address-field>                    
                      </v-flex>
                      <v-flex xs3 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Postcode" v-model="object.details['postal_code']"></fields-d-text-field>                       
                      </v-flex>
                      <v-flex xs3 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Plaats" v-model="object.details['city']"></fields-d-text-field>                       
                      </v-flex>
                      <v-flex xs4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Buurt" v-model="object.details['buurtnaam']"></fields-d-text-field>                       
                      </v-flex>
                      <v-flex xs4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Provincie" v-model="object.details['county']"></fields-d-text-field>                       
                      </v-flex>                      
                      <v-flex xs4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Land" v-model="object.details['country']"></fields-d-text-field>                       
                      </v-flex>
                      <v-flex xs4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Perceel" v-model="object.details['perceel']"></fields-d-text-field>                       
                      </v-flex>

                    <v-flex sm4 xs12 v-for="(field, index) in object.category.fields" :key="index" class="pl-2">
                        <fields-d-text-field    @input="change"             v-if="field.type == 'text'"     :label="field.name" v-model="object.details[field.field]"></fields-d-text-field>                       
                        <fields-d-email-field   @input="change"             v-if="field.type == 'email'"    :label="field.name" v-model="object.details[field.field]"></fields-d-email-field>    
                        <fields-d-phone-field   @input="change"             v-if="field.type == 'phone'"                        v-model="object.details[field.field]"></fields-d-phone-field>    
                        <fields-d-address-field @blur="change"              v-if="field.type == 'address'"                                                           ></fields-d-address-field>
                        <fields-d-address-field @blur="change" estate       v-if="field.type == 'estate'"                                                            ></fields-d-address-field>
                        <fields-d-date-object-field @blur="change"          v-if="field.type == 'date'"     :label="field.name" v-model="object.details[field.field]"></fields-d-date-object-field>                       
                        <fields-d-switch        @input="change"             v-if="field.type == 'switch'"   :label="field.name" v-model="object.details[field.field]"></fields-d-switch>
                        <fields-d-checkbox      @input="change"             v-if="field.type == 'checkbox'" :label="field.name" v-model="object.details[field.field]"></fields-d-checkbox>
                        <fields-d-yes-no        @input="change"             v-if="field.type == 'yes-no'"   :label="field.name" v-model="object.details[field.field]"></fields-d-yes-no>
                        <fields-d-text-area     @input="change"             v-if="field.type == 'textarea'" :label="field.name" v-model="object.details[field.field]"></fields-d-text-area>                       
                    </v-flex> 
                  </v-layout>        

                </v-container>
            
            
            
                <v-container fluid class="pa-5" v-if="objectType == 'person'">
                  <v-layout wrap>
                    
                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Voornaam" v-model="object.details['first_name']"></fields-d-text-field>                       
                      </v-flex>
                      
                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change"  label="Achternaam" v-model="object.details['last_name']" ></fields-d-text-field>                       
                      </v-flex>

                      <v-flex sm2 xs12 class="pl-2">
                        <fields-d-text-field @input="change"  label="Initialen" v-model="object.details['initials']" ></fields-d-text-field>                       
                      </v-flex>

                      <v-flex sm2 xs12 class="pl-2">
                        <v-select @input="change" label="Geslacht" :items="genderList" v-model="object.details['gender']"></v-select>
                      </v-flex>

                      <v-flex sm6 xs12 class="pl-2">
                        <fields-d-address-field  @blur="change"></fields-d-address-field>
                      </v-flex>                    

                      <v-flex sm2 xs12 class="pl-2">
                          <fields-d-date-object-field @blur="change" label="Geboortedatum" v-model="object.details['birth_date']"></fields-d-date-object-field>                       
                      </v-flex>   

                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change"  label="Geboorteplaats" v-model="object.details['birth_place']" ></fields-d-text-field>                       
                      </v-flex>                      
                    
                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-email-field   @input="change" label="Email adres"     v-model="object.details['email']"></fields-d-email-field>    
                      </v-flex>  

                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-phone-field   @input="change" label="Telefoonnummer"  v-model="object.details['phone']"></fields-d-phone-field>    
                      </v-flex>

                      <v-flex sm4 xs12 v-for="(field, index) in object.category.fields" :key="index" class="pl-2">
                          <fields-d-text-field    @input="change"             v-if="field.type == 'text'"     :label="field.name" v-model="object.details[field.field]"></fields-d-text-field>                       
                          <fields-d-email-field   @input="change"             v-if="field.type == 'email'"    :label="field.name" v-model="object.details[field.field]"></fields-d-email-field>    
                          <fields-d-phone-field   @input="change"             v-if="field.type == 'phone'"                        v-model="object.details[field.field]"></fields-d-phone-field>    
                          <fields-d-address-field @blur="change"              v-if="field.type == 'address'"                                                           ></fields-d-address-field>
                          <fields-d-address-field @blur="change" estate       v-if="field.type == 'estate'"                                                            ></fields-d-address-field>
                          <fields-d-date-object-field @blur="change"          v-if="field.type == 'date'"     :label="field.name" v-model="object.details[field.field]"></fields-d-date-object-field>                       
                          <fields-d-switch        @input="change"             v-if="field.type == 'switch'"   :label="field.name" v-model="object.details[field.field]"></fields-d-switch>
                          <fields-d-checkbox      @input="change"             v-if="field.type == 'checkbox'" :label="field.name" v-model="object.details[field.field]"></fields-d-checkbox>
                          <fields-d-yes-no        @input="change"             v-if="field.type == 'yes-no'"   :label="field.name" v-model="object.details[field.field]"></fields-d-yes-no>
                          <fields-d-text-area     @input="change"             v-if="field.type == 'textarea'" :label="field.name" v-model="object.details[field.field]"></fields-d-text-area>                       
                      </v-flex> 
                    </v-layout>                                    
                  </v-container>
                <!-- <forms-confirm-buttons></forms-confirm-buttons> -->
                <v-container fluid class="pa-5" v-if="objectType == 'company'">
                  <v-layout wrap>
                    
                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="Bedrijfsnaam" v-model="object.details['name']"></fields-d-text-field>                       
                      </v-flex>
                      
                      <v-flex sm6 xs12 class="pl-2">
                        <fields-d-address-field  @blur="change"></fields-d-address-field>
                      </v-flex>          
                      
                      <v-flex sm2 xs12 class="pl-2">
                        <v-select @input="change" label="Ondernemingsvorm" :items="businessList" v-model="object.details['business_type']"></v-select>
                      </v-flex>

                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="KVK nummer" v-model="object.details['kvk_number']"></fields-d-text-field>                       
                      </v-flex>

                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-text-field @input="change" label="BTW Nummer" v-model="object.details['vat_number']"></fields-d-text-field>                       
                      </v-flex>
                    


                      
                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-email-field   @input="change" label="Algemeen Email adres"     v-model="object.details['email']"></fields-d-email-field>    
                      </v-flex>  

                      <v-flex sm4 xs12 class="pl-2">
                        <fields-d-phone-field   @input="change" label="Telefoonnummer"  v-model="object.details['phone']"></fields-d-phone-field>    
                      </v-flex>

                      <v-flex sm4 xs12 v-for="(field, index) in object.category.fields" :key="index" class="pl-2">
                          <fields-d-text-field    @input="change"             v-if="field.type == 'text'"     :label="field.name" v-model="object.details[field.field]"></fields-d-text-field>                       
                          <fields-d-email-field   @input="change"             v-if="field.type == 'email'"    :label="field.name" v-model="object.details[field.field]"></fields-d-email-field>    
                          <fields-d-phone-field   @input="change"             v-if="field.type == 'phone'"                        v-model="object.details[field.field]"></fields-d-phone-field>    
                          <fields-d-address-field @blur="change"              v-if="field.type == 'address'"                                                           ></fields-d-address-field>
                          <fields-d-address-field @blur="change" estate       v-if="field.type == 'estate'"                                                            ></fields-d-address-field>
                          <fields-d-date-object-field @blur="change"          v-if="field.type == 'date'"     :label="field.name" v-model="object.details[field.field]"></fields-d-date-object-field>                       
                          <fields-d-switch        @input="change"             v-if="field.type == 'switch'"   :label="field.name" v-model="object.details[field.field]"></fields-d-switch>
                          <fields-d-checkbox      @input="change"             v-if="field.type == 'checkbox'" :label="field.name" v-model="object.details[field.field]"></fields-d-checkbox>
                          <fields-d-yes-no        @input="change"             v-if="field.type == 'yes-no'"   :label="field.name" v-model="object.details[field.field]"></fields-d-yes-no>
                          <fields-d-text-area     @input="change"             v-if="field.type == 'textarea'" :label="field.name" v-model="object.details[field.field]"></fields-d-text-area>                       
                      </v-flex> 
                    </v-layout>                                    
                  </v-container>



                <v-container fluid>
                    <v-layout justify-end="" style="min-height:100px;" class="pr-4">
                      <v-flex xs6 sm3 >
                          <v-slide-x-transition>
                              <v-btn rounded="" block="" v-if="app.form.hasChange" @click="resetObject()" color="warning">Reset</v-btn>
                          </v-slide-x-transition>
                      </v-flex>
                      <v-flex  xs6 sm3 class="pl-3">
                          <v-slide-x-transition>
                              <v-btn rounded="" block="" v-if="app.form.hasChange" @click="updateObject()" color="success">Opslaan</v-btn>
                          </v-slide-x-transition>
                      </v-flex>     
                  </v-layout>
                </v-container>

            </v-card>
        </v-dialog>



</template>

<script>
import { mapState } from "vuex";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      genderList: ["nvt", "vrouw", "man"],
      businessList: [
        "BV",
        "Eenmanszaak",
        "VOF",
        "Maatschap",
        "Coörperatie",
        "Stichting",
        "Vereniging",
        "NV",
        "CV"
      ]
    };
  },
  computed: {
    ...mapState(["object", "app", "temp_address"]),
    ...mapGetters(["headerHeight", "addressDescription"]),
    objectType() {
      if (this.object.category.is_estate == true) {
        return "estate";
      } else if (this.object.category.is_company == true) {
        return "company";
      } else if (this.object.category.is_person == true) {
        return "person";
      } else {
        return "object";
      }
    },
    mapSource() {
      return (
        "https://maps.google.com/maps?q=" +
        this.mapLabel +
        "&output=embed&zoom=18"
      );
    },
    showMap() {
      if (
        this.$store.getters.addressDescription(
          null,
          this.object,
          this.temp_address
        ) !== undefined &&
        this.$store.getters.addressDescription(
          null,
          this.object,
          this.temp_address
        ) != ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    mapLabel() {
      return this.$store.getters.addressDescription(false, this.object, null);
    },
    containsAddress() {
      if (this.objectType == "estate" || this.objectType == "person") {
        return true;
      } else if (this.objectType == "company") {
        return true;
      } else {
        for (var i = 0; i < this.object.category.fields.length; i++) {
          if (this.object.category.fields[i].type == "estate") {
            return true;
          }
          if (this.object.category.fields[i].type == "address") {
            return true;
          }
        }
        return false;
      }
    },
    first_name() {
      return this.object.details.first_name;
    },
    last_name() {
      return this.object.details.last_name;
    }
  },
  methods: {
    ...mapActions(["change", "resetObject", "updateObject"]),
    setName() {
      if (
        this.object.details.first_name != "" &&
        this.object.details.first_name !== undefined
      ) {
        if (
          this.object.details.last_name != "" &&
          this.object.details.last_name !== undefined
        ) {
          this.object.details.name =
            this.object.details.first_name +
            " " +
            this.object.details.last_name;
        }
      }
    }
  },
  watch: {
    first_name() {
      this.setName();
    },
    last_name() {
      this.setName();
    },
    objectType() {
      console.log(this.objectType);
    }
  }
};
</script>

<style scoped>
.custom-card {
  border-radius: 20px !important;
}
.resize {
  min-height: 65vh;
}
</style>
